import React from "react";
import GalletySection from "../components/Gallery/GallerySection";
const Gallery = () => {
    return <GalletySection />;
};

export default Gallery;
